<template>
	<div class="paymenterror">
		<text-headline-primary class="headline">{{ texts.headline }}</text-headline-primary>
		<div class="paymenterror__error">
			<span>{{ texts.errorcodeprefix }}: </span>
			<span class="paymenterror__errorcode">{{ error }}</span>
		</div>
		<div class="paymenterror__errorcodetext">{{ texts.errorcodetext }}</div>
		<div class="paymenterror__erroropentext">{{ texts.erroropentext }}</div>
		<div class="paymenterror__erroropenhours">{{ texts.erroropenhours }}</div>
		<div class="paymenterror__errorphone">{{ texts.errorphone }}</div>

		<text-button class="paymenterror__button" @click.prevent="reload">
			{{ texts.errorrestart }}
		</text-button>
	</div>
</template>

<script>
import TextButton from '@/components/elements/TextButton'

export default {
	components: {
		TextButton,
	},
	computed: {
		error() {
			return this.$route.query.code
		},
		texts() {
			const headline = this.$t('payment_error.error_during_payment')
			const errorcodeprefix = this.$t('payment_error.error_code')
			const errorcodetext = this.$t('payment_error.error_contact_support')
			const erroropentext = this.$t('payment_error.error_open_text')
			const erroropenhours = this.$t('payment_error.error_open_hours')
			const errorphone = this.$t('payment_error.error_phone')
			const errorrestart = this.$t('payment_error.error_restart')

			return {
				headline,
				errorcodeprefix,
				errorcodetext,
				erroropentext,
				erroropenhours,
				errorphone,
				errorrestart,
			}
		},
	},
	methods: {
		reload() {
			this.$router.push({ path: '/' })
		},
	},
}
</script>

<style lang="scss" scoped>
.paymenterror {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 30px;
	text-align: center;

	&__error {
		color: gray;
	}

	&__errorcodetext {
		padding-top: 16px;
	}

	&__errorcode {
	}

	&__erroropentext {
		padding-top: 16px;
	}

	&__errorphone {
		font-weight: bold;
		padding-top: 16px;
	}

	&__button {
		margin-top: 20px;
	}
}
</style>